import { ProductModel } from "states/product/product.models";

interface IProductNameProps {
  product: ProductModel;
}

export function ProductName(props: IProductNameProps) {
  return (
    <span>
      {props?.product?.name}
      {props.product?.unit ? (
        <>
          {" "}
          | <span className="text-danger">{props.product.unit.unitName}</span>
        </>
      ) : null}
      {props.product.variationAttributes?.length > 0 ? (
        <>
          {" "}
          |{" "}
          {props.product.variationAttributes.map((m) => (
            <span className="text-primary">{m.variationValue}</span>
          ))}
        </>
      ) : (
        ""
      )}
    </span>
  );
}
